module.exports = __webpack_public_path__ + "assets/roboto-v20-latin-700.ttf?1784fec0a4aab51ad5cb6b8a65310a07";